import {
  getGlobalCssUrl,
  getComponentCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavFooterLevel0LinkTemplate() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavFooterLevel0Link--wc.css')}" rel="stylesheet" />
`
  return t
}

const getTemplateNavFooterLevel0LinkStyles = () => createNavFooterLevel0LinkTemplate()
export { getTemplateNavFooterLevel0LinkStyles }
